import React, { useState } from 'react';
import { api, clearResourceCache, history } from 'app';
import Page, { Container, PageHeader, PageTitle } from 'components/Page';
import SuccessModal from 'routes/campaign/components/SuccessModal';
import CampaignForm from './components/CampaignForm';

const initialValues = {
  channel: 'email',
  emailUtm: '?utm_source=semail&utm_medium=email&utm_campaign=',
  smsUtm: '',
  description_sms: `_FULL_NAME_LIMITED_ گرامی
    سلام
    شما به «X» دعوت شده اید
    ثبت نام:
    _UNSUBSCRIPTION_GUIDE_`,
  sms_line: '989982007292'
};

function CreateCampaign() {
  const [status, setStatus] = useState('none');
  const [createdCampId, setCreatedCampId] = useState('');

  const handleClose = () => {
    setStatus('none');
    clearResourceCache('campaign');
    history.push(`/campaigns/${createdCampId}/info`);
  };

  function handleSubmit(data) {
    return api
      .post('/advertising-campaigns', data)
      .then(response => response.json())
      .then(response => {
        setCreatedCampId(response.data.id);
        clearResourceCache('campaign', 'collection');
        clearResourceCache('campaign', 'single');
        setStatus('submitSucceeded');
      });
  }

  return (
    <Page>
      <PageHeader>
        <PageTitle>ایجاد کمپین تبلیغاتی جدید</PageTitle>
      </PageHeader>

      <Container size="small">
        <CampaignForm
          initialValues={initialValues}
          name="createCampaign"
          onSubmit={handleSubmit}
          submitButtonText="ایجاد کمپین تبلیغاتی"
        />
      </Container>
      <SuccessModal show={status === 'submitSucceeded'} onHide={handleClose} />
    </Page>
  );
}

export default CreateCampaign;
